(function() {
  'use strict';

  // Function to close mobile dropdown
  function closeMobileDropdown() {
    const dropdown = document.getElementById('mobile-financial-dropdown');
    const button = document.getElementById('mobile-financial-toggle');
    if (dropdown && button) {
      const icon = button.querySelector('i');
      if (dropdown.style.display === 'block') {
        dropdown.style.display = 'none';
        button.classList.remove('active');
        if (icon) {
          icon.className = 'lahi-down-open';
        }
      }
    }
  }

  // Close mobile dropdown when screen size changes to desktop (lg breakpoint: 992px)
  window.addEventListener('resize', function() {
    if (window.innerWidth >= 992) {
      closeMobileDropdown();
    }
  });

  document.addEventListener('click', function(e) {
    if (e.target.closest('#mobile-financial-toggle')) {
      e.preventDefault();
      const button = document.getElementById('mobile-financial-toggle');
      const dropdown = document.getElementById('mobile-financial-dropdown');

      // Guard clause: only proceed if both elements exist
      if (!button || !dropdown) return;

      const icon = button.querySelector('i');

      if (dropdown.style.display === 'none' || dropdown.style.display === '') {
        dropdown.style.display = 'block';
        button.classList.add('active');
        if (icon) {
          icon.className = 'lahi-up-open';
        }
      } else {
        dropdown.style.display = 'none';
        button.classList.remove('active');
        if (icon) {
          icon.className = 'lahi-down-open';
        }
      }
      return;
    }

    // Close dropdown when clicking outside
    if (!e.target.closest('#mobile-financial-toggle') && !e.target.closest('#mobile-financial-dropdown')) {
      const dropdown = document.getElementById('mobile-financial-dropdown');
      const button = document.getElementById('mobile-financial-toggle');

      // Guard clause: only proceed if both elements exist
      if (!button || !dropdown) return;

      const icon = button.querySelector('i');
      if (dropdown.style.display === 'block') {
        dropdown.style.display = 'none';
        button.classList.remove('active');
        if (icon) {
          icon.className = 'lahi-down-open';
        }
      }
    }

    // Handle ribbon toggle icon click
    if (e.target.matches('[data-behavior="ribbon-toggle-icon"]')) {
      e.preventDefault();
      const form = e.target.closest('.ribbon-toggle-form');
      if (form) {
        const submitButton = form.querySelector('input[type="submit"]');
        if (submitButton) {
          submitButton.click();
        }
      }
      return;
    }

    // Handle ribbon toggle form submission
    if (e.target.matches('.ribbon-toggle-form input[type="submit"]')) {
      e.preventDefault();

      const form = e.target.closest('.ribbon-toggle-form');
      const ribbonContainer = form.closest('[data-ribbon-data]');

      if (!ribbonContainer) return;

      // Get current view and determine new view
      const currentView = ribbonContainer.dataset.currentView;
      const newView = currentView === 'total' ? 'ytd' : 'total';

      // Update invested amount and label
      const investedAmountEl = ribbonContainer.querySelector('[data-invested-total]');
      const investedLabelEl = ribbonContainer.querySelector('[data-invested-year-text]');

      // Guard clause: only proceed if both elements exist
      if (!investedAmountEl || !investedLabelEl) return;

      investedAmountEl.textContent = newView === 'total' ? investedAmountEl.dataset.investedTotal : investedAmountEl.dataset.investedYtd;
      investedLabelEl.textContent = newView === 'total' ? investedLabelEl.dataset.investedTotalText : investedLabelEl.dataset.investedYearText;

      // Update invested tooltip content
      const investedTooltipEl = ribbonContainer.querySelector('#invested-tooltip');
      if (investedTooltipEl) {
        const investedTooltipContent = newView === 'total' ? investedTooltipEl.dataset.investedTotalTooltipContent : investedTooltipEl.dataset.investedYearTooltipContent;

        // Destroy existing popover and recreate with new content
        if (window.jQuery) {
          jQuery(investedTooltipEl).popover('dispose');
          investedTooltipEl.setAttribute('data-popover-content', investedTooltipContent);

          // Reinitialize popover with new content
          const settings = {
            trigger: 'hover',
            placement: 'bottom',
            delay: 200,
            container: jQuery(investedTooltipEl),
            html: true,
            content: investedTooltipContent
          };
          jQuery(investedTooltipEl).popover(settings);
        }
      }

      // Update return amount, label, and CSS class
      const returnAmountEl = ribbonContainer.querySelector('[data-return-total]');
      const returnLabelEl = ribbonContainer.querySelector('[data-profit-year-text]');

      if (!returnAmountEl || !returnLabelEl) return;

      // Get percentage element before updating parent textContent
      const percentageEl = returnAmountEl.querySelector('[data-percentage]');
      const percentageHTML = percentageEl ? percentageEl.outerHTML : '';

      returnAmountEl.textContent = newView === 'total' ? returnAmountEl.dataset.returnTotal : returnAmountEl.dataset.returnYtd;
      returnLabelEl.textContent = newView === 'total' ? returnLabelEl.dataset.profitTotalText : returnLabelEl.dataset.profitYearText;
      returnAmountEl.className = newView === 'total' ? returnAmountEl.dataset.returnTotalClass : returnAmountEl.dataset.returnYtdClass;

      // Update mobile navbar return amount if it exists
      const mobileReturnEl = document.querySelector('[data-mobile-return-total]');
      if (mobileReturnEl) {
        mobileReturnEl.textContent = newView === 'total' ? mobileReturnEl.dataset.mobileReturnTotal : mobileReturnEl.dataset.mobileReturnYtd;
        mobileReturnEl.className = newView === 'total' ? mobileReturnEl.dataset.mobileReturnTotalClass : mobileReturnEl.dataset.mobileReturnYtdClass;
      }

      // Update profit/loss tooltip content
      const returnTooltipEl = ribbonContainer.querySelector('#return-tooltip');
      if (returnTooltipEl) {
        const profitTooltipContent = newView === 'total' ? returnTooltipEl.dataset.profitTotalTooltipContent : returnTooltipEl.dataset.profitYearTooltipContent;

        // Destroy existing popover and recreate with new content
        if (window.jQuery) {
          jQuery(returnTooltipEl).popover('dispose');
          returnTooltipEl.setAttribute('data-popover-content', profitTooltipContent);

          // Reinitialize popover with new content
          const settings = {
            trigger: 'hover',
            placement: 'bottom',
            delay: 200,
            container: jQuery(returnTooltipEl),
            html: true,
            content: profitTooltipContent
          };
          jQuery(returnTooltipEl).popover(settings);
        }
      }

      // Restore percentage element and update its content
      if (percentageHTML) {
        returnAmountEl.insertAdjacentHTML('beforeend', percentageHTML);
        const restoredPercentageEl = returnAmountEl.querySelector('[data-percentage]');
        if (restoredPercentageEl) {
          restoredPercentageEl.textContent = newView === 'total' ? restoredPercentageEl.dataset.percentage : '';
        }
      }

      // Update button text
      const yearText = ribbonContainer.dataset.yearText;
      const totalText = ribbonContainer.dataset.totalText;

      // Guard clause: only proceed if both elements exist
      if (!yearText || !totalText) return;

      e.target.value = newView === 'total' ? yearText : totalText;

      // Update current view data attribute
      ribbonContainer.dataset.currentView = newView;

      // Submit form via fetch
      fetch(form.action, {
        method: 'PATCH',
        body: new FormData(form),
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      });
    }
  });
})();
